<template>
  <div class="tree">
    <div :id="blockId"></div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import 'jstree'
import $ from 'jquery'

export default {
  name: 'tree-conponent',
  props: ['inputData', 'multiple', 'initOnMount', 'selectParent'],
  data () {
    return {
      blockId: '_',
      init: true
    }
  },
  created () {
    // console.log('treee')
    this.blockId = 'jstree_' + (100 + Math.floor(500 * Math.random()))
    this.$emit('myIdIs', this.blockId)
    eventBus.$on('deselectIdFromTree', this.deselectIdFromTree)
    eventBus.$on('resetTree', this.clearState)
    this.initTree()
  },
  mounted () {
    if (this.inputData !== undefined) {
      this.initTree(this.inputData)
    }
    if (this.initOnMount === true) {
      this.init = true
      this.initTree(this.inputData)
    }
    /* this.missClick = (item) => {
      let q = document.querySelector(`#${this.blockId}`)
      if (item.target !== q) {
        console.log('qwe')
        $(`#${this.blockId}`).hide()
      }
    }
    document.addEventListener('click', this.missClick) */
  },
  watch: {
    inputData (newVal) {
      if (newVal !== undefined && newVal.length > 0) {
        // console.log('TREE', $(`#${this.blockId}`).jstree(true))
        $(`#${this.blockId}`).jstree('destroy')
        this.init = true
        this.initTree(newVal)
      }
    }
  },
  /* beforeDestroy () {
    document.removeEventListener('click', this.missClick)
  }, */
  methods: {
    clearState () {
      $(`#${this.blockId}`).jstree(true).deselect_all()
    },
    initTree (treeData) {
      if (this.selectParent === true) {
        $(`#${this.blockId}`).jstree({
          plugins: [ 'wholerow', 'checkbox' ],
          core: {
            data: treeData,
            multiple: (this.multiple !== undefined && this.multiple !== null) ? this.multiple : true
          },
          checkbox: {
            'three_state': false
          }
        })
      } else {
        $(`#${this.blockId}`).jstree({
          plugins: [ 'wholerow', 'checkbox' ],
          core: {
            data: treeData,
            multiple: (this.multiple !== undefined && this.multiple !== null) ? this.multiple : true
          }
        })
      }
      $.jstree.defaults.core.themes.variant = 'large'
      if (this.init) {
        this.init = false
        $(`#${this.blockId}`).on('changed.jstree', this.changeData)
      }
    },
    deselectIdFromTree (e) {
      if (e.treeId !== this.blockId) {
        return
      }
      $(`#${e.treeId}`).jstree(true).deselect_node([e.itemId], true)
    },
    changeData (e, data) {
      let _fullinfo = data.selected.map(id => {
        let isParent = $(`#${this.blockId}`).jstree(true).is_parent(id) // смотрим родитель это или нет
        if (this.selectParent === false || this.selectParent === undefined) {
          if (isParent) { // если родитель, то null вместо id(потом удалим)
            return null
          }
        }
        let item = this.inputData.find(elem => {
          return String(elem.id) === String(id)
        })
        if (item !== undefined) {
          return item
        }
      })
      if (this.selectParent === false || this.selectParent === undefined) {
        data.selected = data.selected.filter(item => {
          return !$(`#${this.blockId}`).jstree(true).is_parent(item)
        })
      }
      _fullinfo = _fullinfo.filter(elem => { return elem !== null })
      this.$emit('setSelected', {ids: data.selected, fullInfo: _fullinfo})
    }
  }
}
</script>

<style lang='scss' scoped>
.tree {
  max-height: 71vh;
  overflow: auto!important;
  // width: 400px;
  // height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/tree/TreeComponent.vue